// ============================================
// ALTERAR APENAS ESTA VARIÁVEL:
// 'prod' = Produção
// 'dev' = Desenvolvimento
// ============================================
const ENVIRONMENT = 'prod'; // Mude para 'dev' ou 'prod'

export default ENVIRONMENT;
